import shajs from 'sha.js';

export function login(url, email, password, callback) {
  var pwhash = shajs('sha512').update(password).digest('hex');

  fetch(url + 'WebServices/generic/Authentication.asmx/Authenticate', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email: email, pass: pwhash })
  }).then(function (res) {
    return res.json();
  }).then(function (res) {
    res = res.d;
    if (res.success && res.data) {
      var token = res.data[0].value;
      localStorage.setItem('gm_session_id', token);
      callback(false, token);
    } else {
      callback(res.exception);
    }
  }).catch(function (err) {
    return callback(err);
  });
}

export function changePassword(url, currentPass, newPass, callback) {
  var currentPasswordHash = shajs('sha512').update(currentPass).digest('hex');
  var newPasswordHash = shajs('sha512').update(newPass).digest('hex');
  fetch(url + 'WebServices/generic/Authentication.asmx/ChangePass', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      gm_session_id: getSessionToken()
    },
    body: JSON.stringify({
      currentPass: currentPasswordHash,
      newPass: newPasswordHash
    })
  }).then(function (res) {
    return res.json();
  }).then(function (res) {
    res = res.d;
    if (res.success) {
      callback(null, { success: true });
      return;
    }
    callback(res.exception);
  }).catch(function (err) {
    return callback(err);
  });
}

export function resetPassword(url, email, callback) {
  fetch(url + 'WebServices/generic/Authentication.asmx/ResetPass', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      users: [email]
    })
  }).then(function (res) {
    return res.json();
  }).then(function (res) {
    res = res.d;
    if (res.success) {
      callback(null, { success: true });
      return;
    }
    callback(res.exception);
  }).catch(function (err) {
    return callback(err);
  });
}

export function getSessionToken() {
  return localStorage.getItem('gm_session_id') || false;
}

export function logout() {
  localStorage.removeItem('gm_session_id');
}